<template>
    <div class="details-panel  px-0" >
        <div class="details-panel__body--header">
            {{ getTranslation('maintenance-vue', 'fine_maintenance_title', {name: product.title})}}
        </div>
        <div class="details-panel__body">
            <span v-if="checkCanPurchaseMaintenance != 1">
                <div
                    class="note"
                    v-html="textCannotPurchase"
                    :class="maintenanceStatus[product.id]['status'] == '1' ? '' : 'note-warning'"
                ></div>
                <br>
            </span>

            <template v-if="canPurchaseMaintenance[product.id] !== 'no'">
                {{ getTranslation('maintenance-vue', 'fine_maintenance_text') }}
                <br> <br>
                <div class="custom-control custom-checkbox b-custom-control-lg">
                    <input
                        type="checkbox"
                        :id="'maintenance_' + product.id"
                        v-model="$store.state.cart.maintenance[product.id].status"
                        :value = "product.id"
                        :name = "'maintenance[' + product.id + ']'"
                        @click="addToCart(product)"
                        class="custom-control-input"
                    >
                    <label :for="'maintenance_' + product.id" class="custom-control-label d-flex flex-wrap">
                        {{ getTranslation('maintenance-vue', 'annual_fine_maintenance_subscription', {name: product.name}) }} <span class="ml-auto text-black">{{ priceFormat(totalMaintenance, true) }}</span>
                    </label>

                </div>
            </template>


        </div>
    </div>
</template>


<script>
    export default {
        methods: {
            addToCart(product) {
                this.resetCartStep();
                this.$store.commit('toggleMaintenance', {product: product.id, price: this.totalMaintenance[product.id]});
                this.saveMaintenance();
            },
            resetCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('setMustConfirm', 1);
                this.$store.commit('addPromoLease', {});
            },
            saveMaintenance() {
                let self = this;
                let total = new Object;
                let totalCurrency = new Object;
                let maintenanceType = this.canPurchaseMaintenance[this.product.id];
                if(maintenanceType == 'no') {
                    total[this.product.id] = 0;
                    this.$store.commit('updateMaintenancePrice', {product: this.product.id, price: 0});
                    return total;
                }
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];
                        if (program.product == this.product.id) {

                            if (_.isNil(total[program.product])) {
                                total[program.product] = 0;
                            }

                            total[program.product] += this.getProgramMaintenancePrice(program.id, '', program.product, 'local_quantity', program.local_quantity) +
                                this.getProgramMaintenancePrice(program.id, '', program.product, 'network_quantity', program.network_quantity) +
                                this.getProgramMaintenancePrice(program.id, '', program.product, 'cloud_perpetual_quantity', program.cloud_perpetual_quantity)
                            ;


                            _.forEach(this.currencyList, function (c) {
                                if (_.isNil(totalCurrency[program.product])) {
                                    totalCurrency[program.product] = new Object();
                                }
                                if (_.isNil(totalCurrency[program.product][c])) {
                                    totalCurrency[program.product][c] = 0;
                                }

                                totalCurrency[program.product][c] += self.getProgramMaintenancePrice(program.id, c, program.product, 'local_quantity', program.local_quantity) +
                                    self.getProgramMaintenancePrice(program.id, c, program.product, 'network_quantity', program.network_quantity) +
                                    self.getProgramMaintenancePrice(program.id, c, program.product, 'cloud_perpetual_quantity', program.cloud_perpetual_quantity);

                            });
                        }
                    }
                }

                for (let index1 in total) {
                    total[index1] = (total[index1] > 0) ? total[index1]: 0;
                }
                _.forEach(this.licences, function (program) {
                    if (
                        program.product == self.product.id &&
                        program.maintenance_excluded == false &&
                        (program.licence_type == 'local' || program.licence_type == 'network'|| program.licence_type == 'cloud_perpetual')
                    ) {
                        total[program.product] += self.getProgramMaintenancePrice(program.id, '', program.product, 'local_quantity', program.local_quantity) +
                            self.getProgramMaintenancePrice(program.id, '', program.product, 'network_quantity', program.network_quantity) +
                            self.getProgramMaintenancePrice(program.id, '', program.product, 'cloud_perpetual_quantity', program.cloud_perpetual_quantity);



                        _.forEach(self.currencyList, function (c) {
                            if (_.isNil(totalCurrency[program.product])) {
                                totalCurrency[program.product] = new Object();
                            }
                            if (_.isNil(totalCurrency[program.product][c])) {
                                totalCurrency[program.product][c] = 0;
                            }

                            if (program.licence_type == 'local') {
                                totalCurrency[program.product][c] += self.getProgramMaintenancePrice(program.program_id, c, program.product, 'local_quantity', program.quantity)
                            } else if (program.licence_type == 'network') {
                                totalCurrency[program.product][c] += self.getProgramMaintenancePrice(program.program_id, c, program.product, 'network_quantity', program.quantity)
                            } else if (program.licence_type == 'cloud_perpetual') {
                                totalCurrency[program.product][c] += self.getProgramMaintenancePrice(program.program_id, c, program.product, 'cloud_perpetual_quantity', program.quantity)
                            }

                        });
                    }
                });

                this.$store.commit('updateMaintenancePrice', {
                    product: this.product.id,
                    price: total[this.product.id],
                    totalCurrency: totalCurrency[this.product.id]
                });
            }
        },
        computed: {
            textCannotPurchase() {
                let maintenanceType = this.canPurchaseMaintenance[this.product.id];
                if (maintenanceType == 'su') {
                    return  this.getTranslation('maintenance-vue', 'maintenance_message_single_upgrade');
                } else if(maintenanceType == 'no') {
                    let status = '';
                    if (this.maintenanceStatus[this.product.id]['status'] == 1) {
                        status += '<svg class="mr-2" width="15" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#ffc107" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>';
                    }

                    return status + this.maintenanceStatus[this.product.id]['text'];
                }
                return "";
            },
            totalMaintenance() {
                return this.getProductMaintenancePrice(this.product.id);
            },
            checkCanPurchaseMaintenance() {
                let maintenanceType = this.canPurchaseMaintenance[this.product.id];

                if (maintenanceType == 'no') {
                    return false;
                }

                if (this.totalMaintenance[this.product.id] == 0 || typeof this.totalMaintenance[this.product.id] == "undefined") {
                    return true;
                }

                //need single upgrade first
                let checkSingleUpgrade = 1;

                if (maintenanceType == 'su') {
                    if (this.$store.state.cart.singleUpgrade.hasOwnProperty(this.product.id)) {
                        if (this.$store.state.cart.singleUpgrade[this.product.id].status == false) {
                            checkSingleUpgrade =  0
                        }
                        this.$store.state.cart.singleUpgrade[this.product.id].info.forEach(function (el) {
                            if (el.selected != 1 && el.maintenance_excluded == false) {
                                checkSingleUpgrade =  0;
                            }
                        });
                    }
                }
                return checkSingleUpgrade;
            },
            userLevel() {
                return this.$store.state.cart.userLevel;
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                canPurchaseMaintenance: JSON.parse(window.canPurchaseMaintenance),
                licences: window.licences,
                maintenancePrice: window.maintenancePrice,
                maintenanceStatus: window.maintenanceStatus,
                currencyList: window.currencyList,
                cartPrograms: this.$store.state.cart.programs
            };
        },
        watch: {
            cartPrograms: {
                handler() {
                    this.saveMaintenance();
                },
                deep: true
            },
            userLevel: {
                handler() {
                    this.saveMaintenance();
                },
                deep: true
            },
        },
        beforeMount() {
            this.licences = JSON.parse(this.licences);
            this.saveMaintenance();
        },
        props: {
            product: Object,
        }
    }
</script>
